export enum Portal {
  Admin = 'admin',
  Company = 'company',
  Employee = 'employee',
}

export const AUTH_REFRESH_URL = '/api/v1/auth/refresh';

/** Where a Teams link or connect popup is sent once the portal has done its
 * part. Backend-hosted, because only a Teams-aware page can hand the outcome
 * back to the host that opened the popup. */
export const TEAMS_LINK_END_URL = '/api/v1/teams/tab/link-end';
